export const WORKBOARD_PAGE_NS = 'pages/WorkboardPage';

export const i18n = {
  en: {
    buttons: {
      builder: 'Builder',
    },
    kanbanBoard: {
      empty: {
        title: 'You have no work items yet',
        message:
          'Create your first item and invite other participants in a completely transparent way.',
      },
    },
    errors: {
      cannotCreateWork: 'There was an issue during work creation.',
    },
    menu: {
      import: 'Import',
      export: 'Export',
    },
  },
};
